module.exports = __webpack_public_path__ + "img/ro.e9130a28.svg";